import './AnimatedCircuitry.css';

function AnimatedCircuitry() {
  return (
    <div className="circuitry-container">
      <svg viewBox="0 0 1200 600" className="circuitry-svg" preserveAspectRatio="xMidYMid slice">
        {/* Animated lines creating circuit paths */}
        <g className="circuit-lines">
          <path d="M 100 150 L 300 150 L 300 300" className="line line-1" />
          <path d="M 900 200 L 1100 200 L 1100 400" className="line line-2" />
          <path d="M 200 500 L 400 500 L 400 250" className="line line-3" />
          <path d="M 1000 100 L 800 100 L 800 350" className="line line-4" />
          <path d="M 150 350 L 600 350" className="line line-5" />
          <path d="M 700 200 L 900 200" className="line line-6" />
        </g>

        {/* Animated nodes/connection points */}
        <g className="circuit-nodes">
          <circle cx="300" cy="150" r="6" className="node node-1" />
          <circle cx="300" cy="300" r="6" className="node node-2" />
          <circle cx="1100" cy="200" r="6" className="node node-3" />
          <circle cx="1100" cy="400" r="6" className="node node-4" />
          <circle cx="400" cy="500" r="6" className="node node-5" />
          <circle cx="400" cy="250" r="6" className="node node-6" />
          <circle cx="150" cy="350" r="6" className="node node-7" />
          <circle cx="600" cy="350" r="6" className="node node-8" />
          <circle cx="700" cy="200" r="6" className="node node-9" />
          <circle cx="900" cy="200" r="6" className="node node-10" />
        </g>
      </svg>
    </div>
  );
}

export default AnimatedCircuitry;
